import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth, useOverview } from "./../../hooks";
import React, { useState } from "react";
import { Button } from "./../../Components/ui/button";
import ButtonLoader from "./../../Components/Loader";
import { Input } from "./../../Components/ui/input";
import { emailRegex } from "./../../validation";
import { EmailIdentificationWithTheme } from "./../../api";

const CurrencyButton = ({ code, flag, lastIndex }) => (
  <div
    className={`flex items-center gap-2 px-[10px] md:px-[24px] py-[11px]  ${
      !lastIndex ? "border-r" : ""
    }`}
  >
    <img
      src={flag}
      alt={`${code} flag`}
      className="w-[13px] md:w-6  h-[13px] md:h-6 rounded-full select-none"
    />
    <span className="font-medium text-[8px] md:font-geomanistBold md:text-[14px]">
      {code}
    </span>
  </div>
);

const FirstSection = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const initialEmail = searchParams.get("email") || "";
  const [email, setEmail] = useState(initialEmail);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { setUserList, setFormData, formData, setSignupOtpToken } = useAuth();
  const validateEmail = (email) => {
    return emailRegex.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    sessionStorage?.clear();

    if (!email) {
      setError("Email is required.");
      setLoading(false);

      return;
    }

    if (!validateEmail(email)) {
      setError("Please enter a valid email address.");
      setLoading(false);
      return;
    }
    try {
      const EmailExist = await EmailIdentificationWithTheme(email);
      EmailExist?.data?.otpToken && setSignupOtpToken(EmailExist?.data?.otpToken);

      setError("");

      if (EmailExist?.data?.usernameList?.length === 0) {
        setLoading(false);
        navigate(`/verify-otp?email=${encodeURIComponent(email)}`);
      }

      if (EmailExist?.data?.usernameList?.length > 0) {
        setUserList(EmailExist?.data);
        navigate(`/exist?email=${encodeURIComponent(email)}`);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const { getFlagByCurrencyCode, currencies } = useOverview();

  return (
    <div className="flex flex-col items-center justify-center text-center py-[59px] md:py-[191px] bg-gradient-to-b from-[#FFF0E2] to-[#FFFFFF] md:bg-cover md:bg-no-repeat md:bg-Landing-Background ">
      <div className="space-y-[14px] px-4  ">
        <h1 className="text-[32px] md:text-[52px] leading-[45px] md:leading-[65px] font-[600] md:font-[400] font-IvyJournal">
          <span className="font-[600] md:font-[400]  font-IvyJournal text-blueish">
            A multi-currency
          </span>{" "}
          savings account
        </h1>
        <p className="text-[12px] md:text-[22px] font-[400] leading-[22px]  text-blackShade">
          for you to{" "}
          <span className="font-geomanistBold font-[500] leading-[30px] ">
            save, invest,
          </span>{" "}
          and{" "}
          <span className="font-geomanistBold  font-[500] leading-[30px]">
            spend
          </span>{" "}
          on your global lifestyle
        </p>
      </div>

      {/* Currency Options */}
      <div className="flex bg-white  items-center rounded-full py-2 h-[29px] md:h-[45px] shadow-headerShadow  mt-[16px] lg:mt-[23px]">
        {currencies.map((currency) => (
          <CurrencyButton
            lastIndex={currencies.length - 1 === currencies.indexOf(currency)}
            key={currency.code}
            flag={getFlagByCurrencyCode(currency.code)}
            {...currency}
          />
        ))}
      </div>

      {/* Sign-up Form */}
      <form
        onSubmit={handleSubmit}
        className="flex gap-4  px-[24px] md:min-w-[703px]  mt-[19px] md:mt-[30px] "
      >
        <div className="flex-grow">
          <label
            htmlFor="email"
            className="block text-[12px] md:text-[16px] float-start text-greyish mb-1"
          >
            Email Address
          </label>
          <Input
            type="email"
            id="email"
            value={email}
            onChange={(e) =>
              setEmail(
                e.target.value.toLowerCase(),
                setError(""),
                setFormData({
                  ...formData,
                  email: e.target.value.toLowerCase(),
                })
              )
            }
            className={`w-full font-geomanistBold px-4 py-3 bg-transparent md:bg-white rounded-md border min-h-[32px] md:min-h-[48px]  ${
              error ? "border-red-500" : "  "
            } border-gray-300   `}
          />
          {error && (
            <span className="text-red-500  text-[14px] mt-1 ml-2">{error}</span>
          )}
        </div>
        <Button
          type="submit"
          disabled={loading}
          variant="primary"
          className={`px-[12px] md:px-[36px]  w-auto py-3 bg-blueish  min-h-[32px] md:min-h-[48px] text-white text-[12px] md:text-[20px] leading-[27px] font-[500] font-geomanistMedium rounded-sm hover:bg-blue-600 transition-colors ${
            error ? "self-center mt-1" : "self-end"
          } `}
        >
          {loading && <ButtonLoader className={"mr-2"} />} Get Started
        </Button>
      </form>
    </div>
  );
};

export default FirstSection;
